export default "__VITE_ASSET__e89ae6e0__"